import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { RepeatOrderService } from '@app/shared/services/repeat-order.service';
import { OrderDataService } from '@app/shared/services/order-data.service';
import { TempProductionService } from '@app/shared/services/temp-production.service';
import { forkJoin, of } from 'rxjs';
import { ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';


@Component({
  selector: 'app-printing-test',
  templateUrl: './printing-test.component.html',
  styleUrls: ['./printing-test.component.css']
})
export class PrintingTestComponent implements OnInit {

  tempPrintingForm: FormGroup;
  tickets = []; // Array to hold all ticket numbers
  rowCount: number = 1; // Default row count set to 1

  constructor(
    private formBuilder: FormBuilder,private Router:Router,
    private repeatOrderService: RepeatOrderService,
    private orderDataService: OrderDataService,private tempProductionService:TempProductionService, private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    // Fetch both repeat orders and unsaved orders
    // forkJoin({
    //   repeatOrders: this.repeatOrderService.getAllRepeatOrder(),
    //   unsavedOrders: this.orderDataService.getAllUnsavedOrders()
    // }).subscribe(response => {
    //   // Ensure the response objects are arrays, otherwise set them as empty arrays
    //   const repeatOrders = Array.isArray(response.repeatOrders) ? response.repeatOrders : [];
    //   const unsavedOrders = Array.isArray(response.unsavedOrders) ? response.unsavedOrders : [];

    //   // Combine both orders into a single array (could also add custom properties to differentiate)
    //   this.tickets = [...repeatOrders, ...unsavedOrders];
    //    // Sort tickets in ascending order based on ticketNo
    // this.tickets.sort((a, b) => {
    //   const ticketNoA = a.ticketNo ? a.ticketNo : '';
    //   const ticketNoB = b.ticketNo ? b.ticketNo : '';
    //   return ticketNoA.localeCompare(ticketNoB); // Ensure correct sorting by ticketNo
    // });

    //   this.cdr.detectChanges(); // This forces the UI to update after data is populated

    //   console.log("ticket",this.tickets);
    // });
    forkJoin({
     
      unsavedOrders: this.orderDataService.getAllUnsavedOrders(),
        repeatOrders: this.repeatOrderService.getAllRepeatOrder(),
    }).subscribe(response => {
      // Ensure the response objects are arrays, otherwise set them as empty arrays
    
      const unsavedOrders = Array.isArray(response.unsavedOrders) ? response.unsavedOrders : [];
        const repeatOrders = Array.isArray(response.repeatOrders) ? response.repeatOrders : [];

      // Combine both orders into a single array (could also add custom properties to differentiate)
     
       this.tickets = [...unsavedOrders, ...repeatOrders];
       // Sort tickets in ascending order based on ticketNo
    // this.tickets.sort((a, b) => {
    //   const ticketNoA = a.ticketNo ? a.ticketNo : '';
    //   const ticketNoB = b.ticketNo ? b.ticketNo : '';
    //   return ticketNoA.localeCompare(ticketNoB); // Ensure correct sorting by ticketNo
    // });
    this.tickets.sort((a, b) => {
  const ticketNoA = a.ticketNo ? a.ticketNo : '';
  const ticketNoB = b.ticketNo ? b.ticketNo : '';
  return ticketNoA.localeCompare(ticketNoB);
}).reverse();


      this.cdr.detectChanges(); // This forces the UI to update after data is populated

      console.log("ticket",this.tickets);
    });
    
      // Initialize the form with a default single row
      this.tempPrintingForm = this.formBuilder.group({
        ticketNo: ['', Validators.required],
        jobName: ['', Validators.required],
        // width: ['', Validators.required],
        date: ['', Validators.required],


        refNo: ['', Validators.required],        // Add refNo
        poNumber: ['', Validators.required],      // Add poNumber
        std: ['', Validators.required],           // Add std
        clientName: ['', Validators.required],      // Add customer
        combinedMaterials: this.formBuilder.array([]), // Add combinedMaterials array (FormArray)



        material: ['', Validators.required],
        thickness: ['', Validators.required],
        width: ['', Validators.required],

        shift: ['', Validators.required],
        machine: ['', Validators.required],
        operator: ['', Validators.required],
        usedSize: ['', Validators.required],
        input: ['', Validators.required],
        output: ['', Validators.required],
        ip: ['', Validators.required],
        job: ['', Validators.required],
        shade: ['', Validators.required],
        others: ['', Validators.required],
        rolls: ['', Validators.required],
        wastage: ['', Validators.required],  // We will update this dynamically
        wastagePer: ['', Validators.required],
        jco: ['', Validators.required],
        others2: ['', Validators.required],

        mix: ['', Validators.required],
        fresh: ['', Validators.required],
        returnn: ['', Validators.required],
        consumed: ['', Validators.required],  // We will update this dynamically

        ea: ['', Validators.required],
        ipa: ['', Validators.required],
        butonol: ['', Validators.required],
        tolune: ['', Validators.required],
        otherSol: ['', Validators.required],
        totalSol: ['', Validators.required],  // We will update this dynamically

        extra: ['', Validators.required],   // We will update this dynamically
        kgs: ['', Validators.required],


        
        

       
      });
        // Initially apply enteredRollNo to the first row if provided
    const enteredRollNo = this.tempPrintingForm.get('enteredRollNo')?.value;
    if (enteredRollNo) {
      const rowArray = this.tempPrintingForm.get('row') as FormArray;
      const firstRow = rowArray.at(0); // Get the first row
      firstRow.patchValue({
        rollNo: enteredRollNo  // Set the rollNo of the first row to enteredRollNo
      });
    }


    this.tempPrintingForm.valueChanges.subscribe(() => {
      this.calculateFormValues();
    });
    
  }
  // Method to create a new row (FormGroup)
 

onTicketSelect(event: any): void {
  const selectedTicketNo = event.target.value;
  if (selectedTicketNo) {
    const selectedTicket = this.tickets.find(ticket => ticket.ticketno === selectedTicketNo);
    if (selectedTicket) {
      // const width = selectedTicket.coilWidth || 'Default Width';
      const jobName = selectedTicket.jobName || 'Default Job Name';

      // const material = selectedTicket.combinedMaterials && selectedTicket.combinedMaterials.length > 0 
      // ? selectedTicket.combinedMaterials[0].material // Extracting the material from the first item
      // : 'Default Material'; // Default if no materials found

       
      // Filter combinedMaterials to get process === "PRINTING"
      const printingMaterial = selectedTicket.combinedMaterials
        ? selectedTicket.combinedMaterials.filter(material => material.process === "PRINTING")
        : [];

      // If there are any materials with process "PRINTING", pick the first one, else use default
      const material = printingMaterial.length > 0 
        ? printingMaterial[0].material 
        : ''; // Default if no material is found with process "PRINTING"
        const thickness = printingMaterial.length > 0 
        ? printingMaterial[0].thickness 
        : ''; // Default thickness if no printing material is found
      const width = printingMaterial.length > 0 
        ? printingMaterial[0].width 
        : ''; // Default width if no printing material is found

        
      this.tempPrintingForm.patchValue({
      //  ticketNo: selectedTicket.ticketno,
       jobName: jobName,
      
       // date: selectedTicket.date,
        batch: selectedTicketNo,

        refNo: selectedTicket.refNo || 'Default Ref No',
        poNumber: selectedTicket.poNo || 'Default PO Number',
        clientName: selectedTicket.clientName || 'Default Client Name',
        // std: selectedTicket.std || 'Default STD',
         std: width || 'Default STD',


        material: material, // Setting the material here
        thickness: thickness, // Setting the thickness here
        // width: width, // Setting the material width here
        width: thickness,
     
      });

        // Optionally populate the combinedMaterials array if available in the ticket
        if (selectedTicket.combinedMaterials) {
          this.setCombinedMaterials(selectedTicket.combinedMaterials);
        }
     
    }
  }
}



setCombinedMaterials(materials: any[]) {
  const combinedMaterialsFormArray = this.tempPrintingForm.get('combinedMaterials') as FormArray;

  // Clear any existing materials in the array before adding new ones
  combinedMaterialsFormArray.clear();

  materials.forEach(material => {
    combinedMaterialsFormArray.push(this.formBuilder.group({
      material: [material.material || ''],          
      density: [material.density || ''],            
      gsm: [material.gsm || ''],                    
      matRequired: [material.matRequired || ''],    
      netRm: [material.netRm || ''],                
      process: [material.process || ''],            
      thickness: [material.thickness || ''],        
      waste: [material.waste || ''],                
      width: [material.width || ''],                
      _id: [material._id || '']                     
    }));
  });
}


// Add a new material row
addMaterial(): void {
  const combinedMaterialsFormArray = this.tempPrintingForm.get('combinedMaterials') as FormArray;
  combinedMaterialsFormArray.push(this.formBuilder.group({
    material: [''],
    density: [''],
    gsm: [''],
    matRequired: [''],
    netRm: [''],
    process: [''],
    thickness: [''],
    waste: [''],
    width: [''],
    _id: ['']
  }));
}

// Remove a material row at a specific index
removeMaterial(index: number): void {
  const combinedMaterialsFormArray = this.tempPrintingForm.get('combinedMaterials') as FormArray;
  combinedMaterialsFormArray.removeAt(index);
}

getCombinedMaterialsControls() {
  return (this.tempPrintingForm.get('combinedMaterials') as FormArray).controls;
}




// Method to calculate values dynamically
calculateFormValues(): void {
  const formData = this.tempPrintingForm.value;

  // Temporarily disable change detection to avoid unnecessary rerenders
  this.cdr.detach();

  // Calculate Wastage (ip + job + shade + others)
  const wastageFields = ['ip', 'job', 'shade', 'others'];
  let wastage = 0;
  wastageFields.forEach((field) => {
    const value = parseFloat(formData[field]);
    if (!isNaN(value)) {
      wastage += value;
    }
  });

  // Set the calculated wastage value to the form field if it has changed
  if (this.tempPrintingForm.get('wastage').value !== wastage) {
    this.tempPrintingForm.patchValue({ wastage });
  }

  // Calculate Total Solvents (ea + ipa + butonol + tolune + otherSol)
  const solventsFields = ['ea', 'ipa', 'butonol', 'tolune', 'otherSol'];
  let totalSol = 0;
  solventsFields.forEach((field) => {
    const value = parseFloat(formData[field]);
    if (!isNaN(value)) {
      totalSol += value;
    }
  });

  // Set the calculated totalSol value to the form field if it has changed
  if (this.tempPrintingForm.get('totalSol').value !== totalSol) {
    this.tempPrintingForm.patchValue({ totalSol });
  }

  // Calculate Extra (std - usedSize)
  const std = parseFloat(formData.std);
  const usedSize = parseFloat(formData.usedSize);
  let extra = 0;

  if (!isNaN(std) && !isNaN(usedSize)) {
    extra = std - usedSize; // Perform the calculation
  }

  // Set the calculated extra value to the form field if it has changed
  if (this.tempPrintingForm.get('extra').value !== extra) {
    this.tempPrintingForm.patchValue({ extra });
  }

  // Calculate Consumed ((fresh - return) / 2 + mix)
  const fresh = parseFloat(formData.fresh);
  const returnVal = parseFloat(formData.returnn);  // use "returnn" to avoid conflicts with the reserved keyword `return`
  const mix = parseFloat(formData.mix);
  let consumed = 0;

  if (!isNaN(fresh) && !isNaN(returnVal) && !isNaN(mix)) {
    consumed = (fresh - returnVal) / 2 + mix;  // Perform the calculation
  }

  // Set the calculated consumed value to the form field if it has changed
  if (this.tempPrintingForm.get('consumed').value !== consumed) {
    this.tempPrintingForm.patchValue({ consumed });
  }

  // Re-enable change detection after calculations
  this.cdr.reattach();
}







tempPrinting() {
  console.log(this.tempPrintingForm.value);
  const formData = this.tempPrintingForm.value;

    // Check if calculated fields are correctly set
    console.log('Wastage:', formData.wastage);
    console.log('Total Solvents:', formData.totalSol);
    console.log('Extra:', formData.extra);
    console.log('Consumed:', formData.consumed);
    console.log('ticket:', formData.ticketNo);

  // Prepare data object to save with all rows
  const dataToSave = {
    ticketNo: formData.ticketNo,
    jobName: formData.jobName,
    // width: formData.width,
    date: formData.date,



    refNo: formData.refNo,       // Add refNo
    poNumber: formData.poNumber,   // Add poNumber
    std: formData.std,     // Add std
    clientName: formData.clientName,

    material: formData.material,
    thickness: formData.thickness,
    width: formData.width,


    shift: formData.shift,
        machine: formData.machine,
        operator: formData.operator,
        usedSize: formData.usedSize,
        input: formData.input,
        output: formData. output,
        ip: formData.ip,
        job: formData.job,
        shade: formData.shade,
        others: formData.others,
        rolls: formData.rolls,
        wastage: formData. wastage,
        wastagePer: formData.wastagePer,
        jco: formData.jco,
        others2: formData.others2,

        mix: formData.mix,
        fresh: formData.fresh,
        returnn: formData.returnn,
        consumed: formData.consumed,

        ea: formData.ea,
        ipa: formData.ipa,
        butonol: formData.butonol,
        tolune: formData.tolune,
        otherSol: formData.otherSol,
        totalSol: formData.totalSol,

        extra: formData.extra,
        kgs: formData.kgs,

   
   
  };

   console.log('Data to Save:', dataToSave); // Debug the final data to be saved

  // Call the service to save data
  this.tempProductionService.addTempPrinting(dataToSave).subscribe(
    (response) => {
      console.log('Data saved successfully:', response);
      // Optionally reset form or perform other actions after successful save tempPrintingList
      this.Router.navigateByUrl('/printingProdTable');  // This will redirect to the Table

    },
    (error) => {
      console.error('Error saving data:', error);

      // Check if the error message contains "Ticket number already exists"
      // if (error.error && error.error.message && error.error.message === 'Ticket number already exists') {
      //   alert('This ticket number already exists. You can still save the data.');
      //   // You can choose to save data anyway if needed here, or provide user confirmation.
      // } else {
      //   alert('An error occurred while saving data. Please try again.');
      // }
      
    }
  );
}

}
